import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { toast } from "react-toastify";
import ErrorProps from "../../../Component/Errorprops";

const ComponentModal = ({ mode, handleCloseClick, editData }) => {
  const [parentId, setParentId] = useState([]);
  const [technicalType, setTechnicalType] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {




  }

  const initialValue = {
    code:mode === "Edit" ? editData.code : "",
    componentName: mode === "Edit" ? editData.componentName : "",
    description: mode === "Edit" ? editData.description : "",
    // parentTechId:mode==="Edit"?editData.parentTechId: null,
    standardReference: mode === "Edit" ? editData.standardReference : ""
  };
  const validationSchema = Yup.object().shape({
    code: Yup.string().required("This field is required"),
    componentName: Yup.string().required("This field is required"),
    standardReference: Yup.string().required("This field is required"),
  });
  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true)
    const createLink = masterAPI["component"].create;
    const updateLink = masterAPI["component"].update
    if (mode === "Create") {
      await axiosPrivate.post(`${createLink}`, value).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        console.log(e, "createtechnicalSpecification")
      })
    } else {
      const updateAC = {
        id: editData.id,
        ...value
      }
      await axiosPrivate.put(`${updateLink}`, updateAC).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        console.log(e, "component")
      })
    }

  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.code + "-" + editData.componentName : "New Component"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Component Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Component Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="code">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Component Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="componentName"
                  placeholder="Enter Component Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="componentName">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Description
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="description"
                  placeholder="Enter Description"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                {/* <ErrorMessage name="techSpecName">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage> */}
              </Grid>
             <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Standard Reference
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="standardReference"
                  placeholder="Enter Standard Reference"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="standardReference">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
             
              <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{

                    textTransform: "none",
                    backgroundColor: loading ? "default" : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ComponentModal;
